export type Lang = 'en' | 'fr' | 'es' | 'ar' | 'de' | 'pt';

const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    gallery: 'Gallery',
    blog: 'Blog',
    products: 'Products',
    about: 'About',
    contact: 'Contact',
    language: 'Language',
  },
  hero: {
    cta_primary: 'Request Site Visit',
    cta_secondary: 'View Services',
  },
  stats: {
    installations: 'Installations Completed',
    satisfaction: 'Client Satisfaction',
    support: '24/7 Support',
    experience: 'Years Experience',
  },
  services: {
    title: 'Our Core Services',
    subtitle: 'Comprehensive security and technology solutions for businesses and institutions across Kenya.',
    learn_more: 'Learn More',
  },
  process: {
    title: 'Our Installation Process',
    subtitle: 'A systematic approach that ensures every project is delivered on time, on spec, and to the highest standard.',
    steps: [
      { title: 'Consultation', desc: 'We discuss your requirements, site layout, and security objectives.' },
      { title: 'Site Assessment', desc: 'Our engineers conduct a thorough on-site survey and risk assessment.' },
      { title: 'Custom Proposal', desc: 'We prepare a detailed proposal tailored to your exact needs and budget.' },
      { title: 'Installation', desc: 'Our certified technicians carry out the installation with minimal disruption.' },
      { title: 'Ongoing Support', desc: 'Post-installation support, maintenance contracts and rapid response service.' },
    ],
  },
  testimonials: {
    title: 'Client Success Stories',
    subtitle: 'Trusted by banks, Saccos, businesses and institutions across Kenya.',
  },
  gallery: {
    title: 'Project Gallery',
    subtitle: 'A showcase of our recent installations and engineering projects.',
    all: 'All',
    view: 'View All Projects',
  },
  blog: {
    title: 'Latest Insights',
    subtitle: 'Security tips, industry news and expert advice from the PRIMECREST team.',
    read_more: 'Read More',
    view_all: 'View All Articles',
  },
  products: {
    title: 'Security Products Catalog',
    subtitle: 'Professional-grade security and IT products, supplied and installed by our certified team.',
    all: 'All Categories',
    request_quote: 'Request Quote',
    view_details: 'View Details',
  },
  about: {
    title: 'About PRIMECREST',
    subtitle: 'Your Trusted Security & Technology Partner',
    mission_title: 'Our Mission',
    vision_title: 'Our Vision',
    values_title: 'Our Values',
    mission: 'To provide world-class security and technology solutions that protect people, assets, and information for businesses and institutions across Kenya.',
    vision: 'To be the most trusted security and technology company in East Africa, recognised for excellence, integrity, and innovation.',
    values: ['Integrity', 'Excellence', 'Innovation', 'Reliability', 'Customer Focus'],
  },
  contact: {
    title: 'Get In Touch',
    subtitle: 'Request a free consultation or site assessment. Our team will get back to you within 24 hours.',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    service: 'Service Interested In',
    message: 'Message',
    send: 'Send Message',
    success: 'Your message has been sent successfully! We will contact you shortly.',
    address_title: 'Our Office',
    phone_title: 'Call Us',
    email_title: 'Email Us',
    hours_title: 'Business Hours',
    hours: 'Mon - Fri: 8:00 AM - 6:00 PM\nSat: 9:00 AM - 2:00 PM',
  },
  footer: {
    rights: 'All rights reserved.',
    services_title: 'Services',
    company_title: 'Company',
    newsletter_title: 'Stay Updated',
    newsletter_desc: 'Subscribe to our newsletter for security tips and company news.',
    subscribe: 'Subscribe',
    email_placeholder: 'Your email address',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
  language_modal: {
    title: 'Select Language',
  },
};

const fr = {
  nav: {
    home: 'Accueil',
    services: 'Services',
    gallery: 'Galerie',
    blog: 'Blog',
    products: 'Produits',
    about: 'À propos',
    contact: 'Contact',
    language: 'Langue',
  },
  hero: {
    cta_primary: 'Demander une visite',
    cta_secondary: 'Voir les services',
  },
  stats: {
    installations: 'Installations réalisées',
    satisfaction: 'Satisfaction client',
    support: 'Support 24/7',
    experience: 'Années d\'expérience',
  },
  services: {
    title: 'Nos Services Principaux',
    subtitle: 'Solutions complètes de sécurité et technologie pour les entreprises et institutions au Kenya.',
    learn_more: 'En savoir plus',
  },
  process: {
    title: 'Notre Processus d\'Installation',
    subtitle: 'Une approche systématique garantissant que chaque projet est livré dans les délais.',
    steps: [
      { title: 'Consultation', desc: 'Nous discutons de vos besoins, de la disposition du site et des objectifs de sécurité.' },
      { title: 'Évaluation du site', desc: 'Nos ingénieurs effectuent une étude approfondie sur site.' },
      { title: 'Proposition personnalisée', desc: 'Nous préparons une proposition détaillée adaptée à vos besoins.' },
      { title: 'Installation', desc: 'Nos techniciens certifiés réalisent l\'installation avec une perturbation minimale.' },
      { title: 'Support continu', desc: 'Support après installation, contrats de maintenance et service rapide.' },
    ],
  },
  testimonials: {
    title: 'Témoignages Clients',
    subtitle: 'La confiance des banques, coopératives, entreprises et institutions au Kenya.',
  },
  gallery: {
    title: 'Galerie de Projets',
    subtitle: 'Présentation de nos récentes installations et projets d\'ingénierie.',
    all: 'Tout',
    view: 'Voir tous les projets',
  },
  blog: {
    title: 'Dernières Actualités',
    subtitle: 'Conseils de sécurité, actualités du secteur et expertise de l\'équipe PRIMECREST.',
    read_more: 'Lire la suite',
    view_all: 'Voir tous les articles',
  },
  products: {
    title: 'Catalogue de Produits',
    subtitle: 'Produits de sécurité et IT professionnels, fournis et installés par notre équipe certifiée.',
    all: 'Toutes les catégories',
    request_quote: 'Demander un devis',
    view_details: 'Voir les détails',
  },
  about: {
    title: 'À propos de PRIMECREST',
    subtitle: 'Votre partenaire de confiance en sécurité et technologie',
    mission_title: 'Notre Mission',
    vision_title: 'Notre Vision',
    values_title: 'Nos Valeurs',
    mission: 'Fournir des solutions de sécurité et technologie de classe mondiale pour les entreprises au Kenya.',
    vision: 'Être la société de sécurité et technologie la plus fiable en Afrique de l\'Est.',
    values: ['Intégrité', 'Excellence', 'Innovation', 'Fiabilité', 'Focus Client'],
  },
  contact: {
    title: 'Contactez-nous',
    subtitle: 'Demandez une consultation gratuite. Notre équipe vous répondra dans les 24 heures.',
    name: 'Nom complet',
    email: 'Adresse e-mail',
    phone: 'Numéro de téléphone',
    service: 'Service intéressé',
    message: 'Message',
    send: 'Envoyer',
    success: 'Votre message a été envoyé avec succès!',
    address_title: 'Notre bureau',
    phone_title: 'Appelez-nous',
    email_title: 'E-mail',
    hours_title: 'Heures d\'ouverture',
    hours: 'Lun - Ven: 8h00 - 18h00\nSam: 9h00 - 14h00',
  },
  footer: {
    rights: 'Tous droits réservés.',
    services_title: 'Services',
    company_title: 'Entreprise',
    newsletter_title: 'Restez informé',
    newsletter_desc: 'Abonnez-vous pour recevoir nos conseils de sécurité et nouvelles.',
    subscribe: 'S\'abonner',
    email_placeholder: 'Votre adresse e-mail',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d\'utilisation',
  },
  language_modal: {
    title: 'Choisir la langue',
  },
};

const es = {
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    gallery: 'Galería',
    blog: 'Blog',
    products: 'Productos',
    about: 'Nosotros',
    contact: 'Contacto',
    language: 'Idioma',
  },
  hero: {
    cta_primary: 'Solicitar visita',
    cta_secondary: 'Ver servicios',
  },
  stats: {
    installations: 'Instalaciones completadas',
    satisfaction: 'Satisfacción del cliente',
    support: 'Soporte 24/7',
    experience: 'Años de experiencia',
  },
  services: {
    title: 'Nuestros Servicios Principales',
    subtitle: 'Soluciones integrales de seguridad y tecnología para empresas e instituciones en Kenia.',
    learn_more: 'Saber más',
  },
  process: {
    title: 'Nuestro Proceso de Instalación',
    subtitle: 'Un enfoque sistemático que garantiza que cada proyecto se entregue a tiempo.',
    steps: [
      { title: 'Consulta', desc: 'Discutimos sus requisitos, disposición del sitio y objetivos de seguridad.' },
      { title: 'Evaluación del sitio', desc: 'Nuestros ingenieros realizan una inspección exhaustiva in situ.' },
      { title: 'Propuesta personalizada', desc: 'Preparamos una propuesta detallada adaptada a sus necesidades.' },
      { title: 'Instalación', desc: 'Nuestros técnicos certificados realizan la instalación con mínima interrupción.' },
      { title: 'Soporte continuo', desc: 'Soporte post-instalación, contratos de mantenimiento y servicio rápido.' },
    ],
  },
  testimonials: {
    title: 'Historias de Éxito',
    subtitle: 'Confiado por bancos, cooperativas, empresas e instituciones en Kenia.',
  },
  gallery: {
    title: 'Galería de Proyectos',
    subtitle: 'Muestra de nuestras instalaciones y proyectos de ingeniería recientes.',
    all: 'Todo',
    view: 'Ver todos los proyectos',
  },
  blog: {
    title: 'Últimas Noticias',
    subtitle: 'Consejos de seguridad, noticias de la industria y asesoramiento experto.',
    read_more: 'Leer más',
    view_all: 'Ver todos los artículos',
  },
  products: {
    title: 'Catálogo de Productos',
    subtitle: 'Productos de seguridad e IT profesionales, suministrados e instalados por nuestro equipo.',
    all: 'Todas las categorías',
    request_quote: 'Solicitar presupuesto',
    view_details: 'Ver detalles',
  },
  about: {
    title: 'Sobre PRIMECREST',
    subtitle: 'Su socio de confianza en seguridad y tecnología',
    mission_title: 'Nuestra Misión',
    vision_title: 'Nuestra Visión',
    values_title: 'Nuestros Valores',
    mission: 'Proporcionar soluciones de seguridad y tecnología de clase mundial para empresas e instituciones en Kenia.',
    vision: 'Ser la empresa de seguridad y tecnología más confiable en África Oriental.',
    values: ['Integridad', 'Excelencia', 'Innovación', 'Fiabilidad', 'Enfoque al cliente'],
  },
  contact: {
    title: 'Contáctenos',
    subtitle: 'Solicite una consulta gratuita. Nuestro equipo le responderá en 24 horas.',
    name: 'Nombre completo',
    email: 'Dirección de correo',
    phone: 'Número de teléfono',
    service: 'Servicio de interés',
    message: 'Mensaje',
    send: 'Enviar mensaje',
    success: '¡Su mensaje ha sido enviado con éxito!',
    address_title: 'Nuestra oficina',
    phone_title: 'Llámenos',
    email_title: 'Correo electrónico',
    hours_title: 'Horario de atención',
    hours: 'Lun - Vie: 8:00 AM - 6:00 PM\nSáb: 9:00 AM - 2:00 PM',
  },
  footer: {
    rights: 'Todos los derechos reservados.',
    services_title: 'Servicios',
    company_title: 'Empresa',
    newsletter_title: 'Manténgase actualizado',
    newsletter_desc: 'Suscríbase para recibir consejos de seguridad y noticias de la empresa.',
    subscribe: 'Suscribirse',
    email_placeholder: 'Su dirección de correo',
    privacy: 'Política de privacidad',
    terms: 'Términos de servicio',
  },
  language_modal: {
    title: 'Seleccionar idioma',
  },
};

const ar = {
  nav: {
    home: 'الرئيسية',
    services: 'الخدمات',
    gallery: 'المعرض',
    blog: 'المدونة',
    products: 'المنتجات',
    about: 'من نحن',
    contact: 'اتصل بنا',
    language: 'اللغة',
  },
  hero: {
    cta_primary: 'طلب زيارة موقع',
    cta_secondary: 'عرض الخدمات',
  },
  stats: {
    installations: 'عمليات تركيب مكتملة',
    satisfaction: 'رضا العملاء',
    support: 'دعم على مدار الساعة',
    experience: 'سنوات الخبرة',
  },
  services: {
    title: 'خدماتنا الأساسية',
    subtitle: 'حلول أمنية وتكنولوجية شاملة للشركات والمؤسسات في كينيا.',
    learn_more: 'اعرف المزيد',
  },
  process: {
    title: 'عملية التركيب لدينا',
    subtitle: 'نهج منهجي يضمن تسليم كل مشروع في الوقت المحدد وبأعلى المعايير.',
    steps: [
      { title: 'الاستشارة', desc: 'نناقش متطلباتك وتخطيط الموقع وأهداف الأمن.' },
      { title: 'تقييم الموقع', desc: 'يجري مهندسونا مسحاً ميدانياً شاملاً.' },
      { title: 'اقتراح مخصص', desc: 'نُعدّ اقتراحاً تفصيلياً مصمماً وفق احتياجاتك.' },
      { title: 'التركيب', desc: 'يقوم فنيونا المعتمدون بالتركيب بأقل قدر من الإزعاج.' },
      { title: 'الدعم المستمر', desc: 'دعم ما بعد التركيب وعقود الصيانة والاستجابة السريعة.' },
    ],
  },
  testimonials: {
    title: 'قصص نجاح العملاء',
    subtitle: 'موثوق به من قبل البنوك والتعاونيات والشركات والمؤسسات في كينيا.',
  },
  gallery: {
    title: 'معرض المشاريع',
    subtitle: 'عرض لأحدث تركيباتنا ومشاريعنا الهندسية.',
    all: 'الكل',
    view: 'عرض جميع المشاريع',
  },
  blog: {
    title: 'آخر الأخبار',
    subtitle: 'نصائح أمنية وأخبار الصناعة وخبرات فريق PRIMECREST.',
    read_more: 'اقرأ المزيد',
    view_all: 'عرض جميع المقالات',
  },
  products: {
    title: 'كتالوج المنتجات الأمنية',
    subtitle: 'منتجات أمنية وتقنية معلومات احترافية، يوفرها ويركبها فريقنا المعتمد.',
    all: 'جميع الفئات',
    request_quote: 'طلب عرض سعر',
    view_details: 'عرض التفاصيل',
  },
  about: {
    title: 'عن PRIMECREST',
    subtitle: 'شريكك الموثوق في الأمن والتكنولوجيا',
    mission_title: 'مهمتنا',
    vision_title: 'رؤيتنا',
    values_title: 'قيمنا',
    mission: 'تقديم حلول أمنية وتكنولوجية عالمية المستوى للشركات والمؤسسات في كينيا.',
    vision: 'أن نكون الشركة الأكثر موثوقية في مجال الأمن والتكنولوجيا في شرق أفريقيا.',
    values: ['النزاهة', 'التميز', 'الابتكار', 'الموثوقية', 'التركيز على العميل'],
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'اطلب استشارة مجانية. سيتواصل معك فريقنا خلال 24 ساعة.',
    name: 'الاسم الكامل',
    email: 'عنوان البريد الإلكتروني',
    phone: 'رقم الهاتف',
    service: 'الخدمة المطلوبة',
    message: 'الرسالة',
    send: 'إرسال الرسالة',
    success: 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.',
    address_title: 'مكتبنا',
    phone_title: 'اتصل بنا',
    email_title: 'البريد الإلكتروني',
    hours_title: 'ساعات العمل',
    hours: 'الإثنين - الجمعة: 8:00 ص - 6:00 م\nالسبت: 9:00 ص - 2:00 م',
  },
  footer: {
    rights: 'جميع الحقوق محفوظة.',
    services_title: 'الخدمات',
    company_title: 'الشركة',
    newsletter_title: 'ابق على اطلاع',
    newsletter_desc: 'اشترك للحصول على نصائح أمنية وأخبار الشركة.',
    subscribe: 'اشترك',
    email_placeholder: 'عنوان بريدك الإلكتروني',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
  },
  language_modal: {
    title: 'اختر اللغة',
  },
};

const de = {
  nav: {
    home: 'Startseite',
    services: 'Leistungen',
    gallery: 'Galerie',
    blog: 'Blog',
    products: 'Produkte',
    about: 'Über uns',
    contact: 'Kontakt',
    language: 'Sprache',
  },
  hero: {
    cta_primary: 'Besichtigungstermin anfragen',
    cta_secondary: 'Leistungen ansehen',
  },
  stats: {
    installations: 'Abgeschlossene Installationen',
    satisfaction: 'Kundenzufriedenheit',
    support: '24/7 Support',
    experience: 'Jahre Erfahrung',
  },
  services: {
    title: 'Unsere Kernleistungen',
    subtitle: 'Umfassende Sicherheits- und Technologielösungen für Unternehmen in Kenia.',
    learn_more: 'Mehr erfahren',
  },
  process: {
    title: 'Unser Installationsprozess',
    subtitle: 'Ein systematischer Ansatz, der sicherstellt, dass jedes Projekt pünktlich geliefert wird.',
    steps: [
      { title: 'Beratung', desc: 'Wir besprechen Ihre Anforderungen und Sicherheitsziele.' },
      { title: 'Standortbewertung', desc: 'Unsere Ingenieure führen eine gründliche Vor-Ort-Prüfung durch.' },
      { title: 'Individuelles Angebot', desc: 'Wir erstellen ein detailliertes Angebot passend zu Ihren Bedürfnissen.' },
      { title: 'Installation', desc: 'Unsere zertifizierten Techniker führen die Installation durch.' },
      { title: 'Laufende Unterstützung', desc: 'Support nach der Installation, Wartungsverträge und Schnellservice.' },
    ],
  },
  testimonials: {
    title: 'Kundenerfolgsgeschichten',
    subtitle: 'Vertraut von Banken, Genossenschaften und Institutionen in Kenia.',
  },
  gallery: {
    title: 'Projektgalerie',
    subtitle: 'Eine Auswahl unserer neuesten Installationen und Ingenieurprojekte.',
    all: 'Alle',
    view: 'Alle Projekte ansehen',
  },
  blog: {
    title: 'Neueste Einblicke',
    subtitle: 'Sicherheitstipps, Branchennews und Expertenrat vom PRIMECREST-Team.',
    read_more: 'Weiterlesen',
    view_all: 'Alle Artikel ansehen',
  },
  products: {
    title: 'Sicherheitsprodukt-Katalog',
    subtitle: 'Professionelle Sicherheits- und IT-Produkte, geliefert und installiert von unserem Team.',
    all: 'Alle Kategorien',
    request_quote: 'Angebot anfragen',
    view_details: 'Details ansehen',
  },
  about: {
    title: 'Über PRIMECREST',
    subtitle: 'Ihr vertrauenswürdiger Sicherheits- & Technologiepartner',
    mission_title: 'Unsere Mission',
    vision_title: 'Unsere Vision',
    values_title: 'Unsere Werte',
    mission: 'Weltklasse-Sicherheits- und Technologielösungen für Unternehmen in Kenia bereitzustellen.',
    vision: 'Das vertrauenswürdigste Sicherheits- und Technologieunternehmen in Ostafrika zu sein.',
    values: ['Integrität', 'Exzellenz', 'Innovation', 'Zuverlässigkeit', 'Kundenfokus'],
  },
  contact: {
    title: 'Kontakt aufnehmen',
    subtitle: 'Fordern Sie eine kostenlose Beratung an. Unser Team meldet sich innerhalb von 24 Stunden.',
    name: 'Vollständiger Name',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    service: 'Gewünschter Service',
    message: 'Nachricht',
    send: 'Nachricht senden',
    success: 'Ihre Nachricht wurde erfolgreich gesendet!',
    address_title: 'Unser Büro',
    phone_title: 'Rufen Sie uns an',
    email_title: 'E-Mail',
    hours_title: 'Geschäftszeiten',
    hours: 'Mo - Fr: 8:00 - 18:00 Uhr\nSa: 9:00 - 14:00 Uhr',
  },
  footer: {
    rights: 'Alle Rechte vorbehalten.',
    services_title: 'Leistungen',
    company_title: 'Unternehmen',
    newsletter_title: 'Auf dem Laufenden bleiben',
    newsletter_desc: 'Abonnieren Sie unseren Newsletter für Sicherheitstipps.',
    subscribe: 'Abonnieren',
    email_placeholder: 'Ihre E-Mail-Adresse',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
  },
  language_modal: {
    title: 'Sprache auswählen',
  },
};

const pt = {
  nav: {
    home: 'Início',
    services: 'Serviços',
    gallery: 'Galeria',
    blog: 'Blog',
    products: 'Produtos',
    about: 'Sobre',
    contact: 'Contacto',
    language: 'Idioma',
  },
  hero: {
    cta_primary: 'Solicitar visita ao local',
    cta_secondary: 'Ver serviços',
  },
  stats: {
    installations: 'Instalações concluídas',
    satisfaction: 'Satisfação do cliente',
    support: 'Suporte 24/7',
    experience: 'Anos de experiência',
  },
  services: {
    title: 'Os Nossos Serviços',
    subtitle: 'Soluções abrangentes de segurança e tecnologia para empresas e instituições no Quénia.',
    learn_more: 'Saber mais',
  },
  process: {
    title: 'O Nosso Processo de Instalação',
    subtitle: 'Uma abordagem sistemática que garante que cada projeto é entregue a tempo.',
    steps: [
      { title: 'Consulta', desc: 'Discutimos os seus requisitos e objetivos de segurança.' },
      { title: 'Avaliação do local', desc: 'Os nossos engenheiros realizam uma inspeção detalhada no local.' },
      { title: 'Proposta personalizada', desc: 'Preparamos uma proposta detalhada adaptada às suas necessidades.' },
      { title: 'Instalação', desc: 'Os nossos técnicos certificados realizam a instalação com mínima perturbação.' },
      { title: 'Suporte contínuo', desc: 'Suporte pós-instalação, contratos de manutenção e serviço rápido.' },
    ],
  },
  testimonials: {
    title: 'Histórias de Sucesso',
    subtitle: 'Confiado por bancos, cooperativas, empresas e instituições no Quénia.',
  },
  gallery: {
    title: 'Galeria de Projetos',
    subtitle: 'Apresentação das nossas instalações e projetos de engenharia recentes.',
    all: 'Todos',
    view: 'Ver todos os projetos',
  },
  blog: {
    title: 'Últimas Notícias',
    subtitle: 'Dicas de segurança, notícias do setor e aconselhamento especializado.',
    read_more: 'Ler mais',
    view_all: 'Ver todos os artigos',
  },
  products: {
    title: 'Catálogo de Produtos',
    subtitle: 'Produtos de segurança e TI profissionais, fornecidos e instalados pela nossa equipa.',
    all: 'Todas as categorias',
    request_quote: 'Solicitar orçamento',
    view_details: 'Ver detalhes',
  },
  about: {
    title: 'Sobre a PRIMECREST',
    subtitle: 'O seu parceiro de confiança em segurança e tecnologia',
    mission_title: 'A Nossa Missão',
    vision_title: 'A Nossa Visão',
    values_title: 'Os Nossos Valores',
    mission: 'Fornecer soluções de segurança e tecnologia de classe mundial para empresas no Quénia.',
    vision: 'Ser a empresa de segurança e tecnologia mais confiável na África Oriental.',
    values: ['Integridade', 'Excelência', 'Inovação', 'Fiabilidade', 'Foco no cliente'],
  },
  contact: {
    title: 'Entre em contacto',
    subtitle: 'Solicite uma consulta gratuita. A nossa equipa responderá em 24 horas.',
    name: 'Nome completo',
    email: 'Endereço de e-mail',
    phone: 'Número de telefone',
    service: 'Serviço de interesse',
    message: 'Mensagem',
    send: 'Enviar mensagem',
    success: 'A sua mensagem foi enviada com sucesso!',
    address_title: 'O nosso escritório',
    phone_title: 'Ligue-nos',
    email_title: 'E-mail',
    hours_title: 'Horário de funcionamento',
    hours: 'Seg - Sex: 8:00 - 18:00\nSáb: 9:00 - 14:00',
  },
  footer: {
    rights: 'Todos os direitos reservados.',
    services_title: 'Serviços',
    company_title: 'Empresa',
    newsletter_title: 'Fique atualizado',
    newsletter_desc: 'Subscreva para receber dicas de segurança e notícias da empresa.',
    subscribe: 'Subscrever',
    email_placeholder: 'O seu endereço de e-mail',
    privacy: 'Política de privacidade',
    terms: 'Termos de serviço',
  },
  language_modal: {
    title: 'Selecionar idioma',
  },
};

export const translations: Record<Lang, typeof en> = { en, fr, es, ar, de, pt };
